import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { PostAuthInstituicaoBody, PostAuthInstituicaoResponse } from './auth-api.interface';

@Injectable({
  providedIn: 'root',
})
export class AuthApiService {
  constructor(private http: HttpClient) {}

  postLogin(body: PostAuthInstituicaoBody) {
    return this.http.post<PostAuthInstituicaoResponse>(`${environment.api}/auth/login`, body);
  }
}
